import { AxiosResponse } from 'axios';
import api from './api';

function path(endPath: string = ''): string {
    return `/depth${endPath}`;
}

//=================================================================================================
export class DepthService {
    static async byKosa(kosaId: number): Promise<AxiosResponse> {
        return api.get(path(`/${kosaId}`));
    }

    //-------------------------------------------------------------------------------------------------
    static updateToKosa(kosaId: number, data: number[]): Promise<AxiosResponse> {
        return api.put(path(`/${kosaId}`), data);
    }

    static async loadFromFactory(kosaSn: number): Promise<AxiosResponse> {
        return api.get(path(`/factory/${kosaSn}`));
    }
}
